import React, { useState, useEffect } from 'react';
import { academicAPI, studentsAPI } from '../../services/api';
import DataTable from '../../components/common/DataTable';
import SearchBar from '../../components/common/SearchBar';
import Modal from '../../components/common/Modal';
import toast from 'react-hot-toast';
import EventsHolidays from './EventsHolidays';
import Input from '../../components/common/Input';
import TimeTable from './TimeTable';
import Assignments from './Assignments';


const AcademicManagement = () => {
  const [tab, setTab] = useState('subjects');
  const [subjects, setSubjects] = useState([]);
  const [loading, setLoading] = useState(false);
  const [classes, setClasses] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [assignments, setAssignments] = useState([]);
  const [form, setForm] = useState({ name: '', code: '', class_obj: '', max_marks: 100, pass_marks: 35, curriculam: '',});



  useEffect(() => {
    studentsAPI.classes().then(r => setClasses(r.data.results || r.data)).catch(() => { });
    loadSubjects();
    loadAssignments();
  }, []);

  

const handleChange = (e) => {
  const { name, value } = e.target;

  setForm((prev) => ({
    ...prev,
    [name]: value,
  }));
};

  const loadSubjects = () => {
    setLoading(true);
    academicAPI.subjects().then(r => setSubjects(r.data.results || r.data)).catch(() => toast.error('Failed')).finally(() => setLoading(false));
  };

  const loadAssignments = () => {
    academicAPI.assignments().then(r => setAssignments(r.data.results || r.data)).catch(() => { });
  };

  const handleSaveSubject = async (e) => {
    e.preventDefault();
    try {
      await academicAPI.createSubject(form);
      toast.success('Subject added!');
      setShowModal(false);
      loadSubjects();
      setForm({ name: '', code: '', class_obj: '', max_marks: 100, pass_marks: 35 });
    } catch { toast.error('Failed to add subject'); }
  };

  const subjectColumns = [
    { key: 'code', label: 'Code', render: v => <code>{v}</code> },
    { key: 'name', label: 'Subject Name', render: v => <strong>{v}</strong> },
    { key: 'class_name', label: 'Class' },
    { key: 'max_marks', label: 'Max Marks' },
    { key: 'pass_marks', label: 'Pass Marks' },
    { key: 'is_elective', label: 'Type', render: v => <span className={`badge ${v ? 'bg-warning text-dark' : 'bg-primary'}`}>{v ? 'Elective' : 'Compulsory'}</span> },
  ];

  const assignmentColumns = [
    { key: 'title', label: 'Assignment', render: v => <strong>{v}</strong> },
    { key: 'subject_name', label: 'Subject' },
    { key: 'due_date', label: 'Due Date' },
    { key: 'max_marks', label: 'Max Marks' },
  ];

  return (
    <div>
      {/* <div className="page-header mb-0">
        <div><h2>Academic Management</h2><p>Subjects, timetables, syllabus and assignments</p></div>
        {tab === 'subjects' && <button className="btn btn-primary" onClick={() => setShowModal(true)}>➕ Add Subject</button>}
        {tab === 'assignments' && <button className="btn btn-primary" onClick={() => setShowModal(true)}>➕ Add Assignment</button>}
      </div> */}

      <div className="d-flex justify-content-between mb-4 flex-wrap ">
        <div className='d-flex gap-2'>
          {[['subjects', '📚 Subjects'], ['timetable', '🕒 Timetable'], ['syllabus', '📋 Syllabus'], ['assignments', '📝 Assignments'], ['EventsHolidays', '📋 Events & Holidays '],].map(([k, l]) => (
            <button key={k} className={`btn ${tab === k ? 'btn-primary' : 'btn-outline-secondary'}`} onClick={() => setTab(k)}>{l}</button>
          ))}
        </div>

        {tab === 'subjects' && <button className="btn-add" onClick={() => setShowModal(true)}>➕ Add Subject</button>}
      </div>

      {tab === 'subjects' && (
        <div className="card">
          <div className="card-header"><span>📚 Subjects ({subjects.length})</span></div>
          <DataTable columns={subjectColumns} data={subjects} loading={loading} />
        </div>
      )}

      {tab === 'timetable' && (
        <div className="card"><div className="card-body">
          
            <TimeTable/>
          {/* <div className="alert alert-info">📅 Select a class and section to view or edit the timetable.</div> */}
          {/* <div className="empty-state"><div className="empty-icon">🕒</div><h5>No Timetable Set</h5><p>Add timetable entries for the selected class.</p></div> */}
        </div></div>
      )}

      {tab === 'syllabus' && (
        <div className="card"><div className="card-body">
          <div className="empty-state"><div className="empty-icon">📋</div><h5>Syllabus Management</h5><p>Plan and track curriculum coverage for each subject.</p></div>
        </div></div>
      )}

      {tab === 'assignments' && (
        <div className="card">
          {/* <div className="card-header"><span>📝 Assignments ({assignments.length})</span></div> */}
          <Assignments/>
          {/* <DataTable columns={assignmentColumns} data={assignments} loading={false} /> */}
        </div>
      )}

      {tab === 'EventsHolidays' && (
        <EventsHolidays />
      )}

      <Modal show={showModal} onClose={() => setShowModal(false)} title="Add Subject">
        <form onSubmit={handleSaveSubject}>
          <div className="mb-3">
            {/* <label className="form-label">Curriculum</label>
            <select className="form-select" value={form.class_obj} onChange={e => setForm({ ...form, class_obj: e.target.value })} required>
              <option value="">Select Class</option>
              {classes.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select> */}
           <Input
		  label="Curriculum"
		  name="curriculam"
		  elementType="select"
		  value={form.curriculam || ""}
		  onChange={handleChange}
		  options={[
			{ value: "", label: "-- Select Curriculum --" },
			{ value: "SSC", label: "SSC/State Board" },
			{ value: "CBSE", label: "CBSE" },
			{ value: "ICSE", label: "ICSE" },
			{ value: "NIOS", label: "NIOS" },
			{ value: "IB", label: "IB" },
		  ]}
		/>
          </div>
          <div className="mb-3"><label className="form-label">Subject Code *</label><input className="form-control" value={form.code} onChange={e => setForm({ ...form, code: e.target.value })} required /></div>
          <div className="mb-3"><label className="form-label">Subject Name *</label><input className="form-control" value={form.name} onChange={e => setForm({ ...form, name: e.target.value })} required /></div>
          <div className="mb-3"><label className="form-label">Class *</label>
            <select className="form-select" value={form.class_obj} onChange={e => setForm({ ...form, class_obj: e.target.value })} required>
              <option value="">Select Class</option>
              {classes.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </div>
          {/* <div className="row">
            <div className="col-6 mb-3"><label className="form-label">Max Marks</label><input type="number" className="form-control" value={form.max_marks} onChange={e => setForm({...form, max_marks: e.target.value})} /></div>
            <div className="col-6 mb-3"><label className="form-label">Pass Marks</label><input type="number" className="form-control" value={form.pass_marks} onChange={e => setForm({...form, pass_marks: e.target.value})} /></div>
          </div> */}
          <div className="d-flex gap-2 justify-content-end">
            <button type="button" className="btn btn-outline-secondary" onClick={() => setShowModal(false)}>Cancel</button>
            <button type="submit" className="btn btn-primary">Add Subject</button>
          </div>
        </form>
      </Modal>
    </div>
  );
};
export default AcademicManagement;
